import { gql } from 'apollo-boost';

export const CATEGORY_QUERY = gql`
query category( $categoryId: UUID! ) {
    category( categoryID: $categoryId ) {
        node {
            id
            locales {
                code
                name
                description
            }
            sortOrder
            brand {
                id
                name
                slug
                segmentId
            }
        }
    }
}`;